if (!customElements.get('cart-drawer-recommendations')) {
  class CartDrawerRecommendations extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.drawerObserver = null;
      this.cartUpdateUnsubscriber = undefined;
      this.onAddClick = this.onAddClick.bind(this);
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.onDrawerClassChange = this.onDrawerClassChange.bind(this);
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-ru-cart-rec-carousel]');
      this.prevBtn = this.querySelector('.ru-cart-rec__nav--prev');
      this.nextBtn = this.querySelector('.ru-cart-rec__nav--next');

      if (!this.carousel) return;

      this.carousel.addEventListener('click', this.onAddClick);

      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate);
      }

      this.bindDrawerOpen();
      this.tryLoad();
    }

    disconnectedCallback() {
      this.destroySwiper();
      this.drawerObserver?.disconnect();
      this.carousel?.removeEventListener('click', this.onAddClick);
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    bindDrawerOpen() {
      const drawer = this.closest('cart-drawer');
      if (!drawer) return;

      this.drawerObserver = new MutationObserver(this.onDrawerClassChange);
      this.drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    onDrawerClassChange() {
      const drawer = this.closest('cart-drawer');
      if (drawer?.classList.contains('active')) {
        this.tryLoad();
      }
    }

    tryLoad() {
      const drawer = this.closest('cart-drawer');
      if (!drawer?.classList.contains('active')) return;
      this.loadRecommendations();
    }

    onCartUpdate(event) {
      if (event?.source === 'cart-drawer-recommendations') return;
      this.tryLoad();
    }

    loadRecommendations() {
      const productId = this.dataset.productId;
      if (!productId) {
        this.hide();
        return;
      }

      const url = `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`;

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`recommendations_${response.status}`);
          return response.text();
        })
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const content = doc.querySelector('[data-ru-cart-rec-content]');
          const swiperMarkup = content?.querySelector('.ru-cart-rec__swiper');

          this.destroySwiper();
          this.carousel.innerHTML = '';

          if (!swiperMarkup) {
            this.hide();
            return;
          }

          const slideCount = Number(swiperMarkup.dataset.ruCartRecSlides || 0);
          this.carousel.appendChild(swiperMarkup);

          if (slideCount <= 0) {
            this.hide();
            return;
          }

          this.show();
          this.toggleNav(slideCount > 1);
          this.initSwiper(slideCount > 1);
          this.refreshJudgeMe();
        })
        .catch((error) => {
          console.error(error);
          this.hide();
        });
    }

    initSwiper(enableNav) {
      if (typeof Swiper === 'undefined') {
        window.setTimeout(() => this.initSwiper(enableNav), 100);
        return;
      }

      const swiperEl = this.carousel.querySelector('.ru-cart-rec__swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        watchOverflow: true,
        autoHeight: true,
        breakpoints: {
          750: {
            slidesPerView: 2.05,
          }
        },
        navigation: enableNav
          ? {
              prevEl: this.prevBtn,
              nextEl: this.nextBtn,
            }
          : false,
      });

      window.requestAnimationFrame(() => this.swiper?.update());
    }

    destroySwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    toggleNav(show) {
      if (!this.prevBtn || !this.nextBtn) return;
      this.prevBtn.hidden = !show;
      this.nextBtn.hidden = !show;
    }

    show() {
      this.hidden = false;
      this.classList.remove('ru-cart-rec-host--pending');
    }

    hide() {
      this.hidden = true;
      this.classList.add('ru-cart-rec-host--pending');
      this.toggleNav(false);
      this.destroySwiper();
      if (this.carousel) this.carousel.innerHTML = '';
    }

    refreshJudgeMe() {
      if (window.jdgm?.customizeBadges) window.jdgm.customizeBadges();
      if (window.jdgm?.widgets?.load) window.jdgm.widgets.load();
    }

    onAddClick(event) {
      const button = event.target.closest('.ru-cart-rec__add');
      if (!button || button.disabled || button.classList.contains('loading')) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const cart = document.querySelector('cart-drawer');
      if (!cart) return;

      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');

      const payload = {
        items: [{ id: Number(variantId), quantity: 1 }],
      };

      if (typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
        payload.sections_url = window.location.pathname;
      }

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(button);
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) throw new Error(response.description || 'cart_add_failed');

          if (response.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
          }

          fetch('/cart.js')
            .then((res) => res.json())
            .then((cartData) => {
              const host = document.querySelector('cart-drawer-recommendations');
              if (host) {
                if (!cartData.items?.length) {
                  host.hide();
                } else {
                  host.dataset.productId = String(cartData.items[0].product_id);
                  host.tryLoad();
                }
              }

              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-drawer-recommendations',
                  cartData,
                });
              }
            })
            .catch((error) => {
              console.error(error);
              const host = document.querySelector('cart-drawer-recommendations');
              host?.tryLoad?.();

              if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'cart-drawer-recommendations',
                });
              }
            });
        })
        .catch((error) => {
          console.error(error);
          const message =
            (window.RuCartErrors && window.RuCartErrors.resolve(error)) ||
            error?.message ||
            window.cartStrings?.error ||
            '';
          if (window.RuCartErrors) {
            window.RuCartErrors.showCartInlineError(message);
          }
          window.alert(message);
        })
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
        });
    }
  }

  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
